/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '../translation.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private currentValue = '';
  private translationSubscription?: Subscription;
  private translateService = inject(TranslationService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  ngOnDestroy(): void {
    this.translationSubscription?.unsubscribe();
  }

  transform(key: string, params?: Record<string, any>): string {
    this.translationSubscription?.unsubscribe();
    this.translationSubscription = this.translateService.getTranslation(key)
      .subscribe((value: string) => {
        let processedValue = value;

        if (params && typeof params === 'object') {
          for (const [paramKey, paramValue] of Object.entries(params)) {
            // Replace {{ key }} with {{key}} format first
            const spacedPlaceholder = `{{ ${paramKey} }}`;
            const compactPlaceholder = `{{${paramKey}}}`;

            // Replace spaced format with compact format
            processedValue = processedValue.replace(
              new RegExp(spacedPlaceholder.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'),
              compactPlaceholder
            );

            // Replace the compact placeholder with the actual value
            processedValue = processedValue.replace(
              new RegExp(compactPlaceholder.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'),
              paramValue
            );
          }
        }

        if (this.currentValue !== processedValue) {
          this.currentValue = processedValue;
          this.changeDetectorRef.markForCheck();
        }
      });

    return this.currentValue || key.split('.').pop() || '';
  }
}